import { Component, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { debounceTime } from 'rxjs/operators'
import { Subscription } from 'rxjs'
import { QueryBuilderService } from '../query-builder.service'
import { IRule, IRuleChangeEvent } from '../rule.model'

@Component({
    selector: 'app-rule',
    templateUrl: './rule.component.html',
    styleUrls: ['./rule.component.scss'],
    standalone: false
})
export class RuleComponent implements OnInit, OnDestroy {
  @Input() ruleInput: IRule
  @Input() level: number = 1
  @Input() index: number = 0
  @Output() removeRuleEvent: EventEmitter<number> = new EventEmitter<number>()
  @Output() ruleChangeEvent: EventEmitter<IRuleChangeEvent> = new EventEmitter<IRuleChangeEvent>()

  public ruleForm: UntypedFormGroup
  public ruleFieldControl: UntypedFormControl
  public ruleOperatorControl: UntypedFormControl
  public ruleValueControl: UntypedFormControl

  private _subscription: Subscription
  private _rule: IRule

  private _variables: { name: string; type: string }[] = []
  private _fields: string[] = []
  private _operators: string[] = []
  private _values: string[] = []

  public get fields(): string[] {
    return this._fields
  }

  public get operators(): string[] {
    return this._operators
  }

  public get values(): string[] {
    return this._values
  }

  constructor(private service: QueryBuilderService) {}

  public onRemoveRule(): void {
    this.removeRuleEvent.next(this.index)
  }

  public onValueChange(): void {
    if (this._rule) {
      this.ruleChangeEvent.next({ index: this.index, rule: this._rule })
    }
  }

  public onChangeVariable(e) {
    // Get Variable Type Here
  }

  private initControls(): void {
    this.ruleFieldControl = new UntypedFormControl(null, [Validators.required])
    this.ruleOperatorControl = new UntypedFormControl(null, [Validators.required])
    this.ruleValueControl = new UntypedFormControl('Active', [Validators.required])
  }

  private initForm(): void {
    this.ruleForm = new UntypedFormGroup({
      ruleFieldControl: this.ruleFieldControl,
      ruleOperatorControl: this.ruleOperatorControl,
      ruleValueControl: this.ruleValueControl,
    })
  }

  private watch(): void {
    this._subscription = this.ruleForm.valueChanges
      .pipe(debounceTime(200))
      .subscribe((formData: any) => {
        if (this.ruleForm.valid) {
          this._rule = {
            field: formData.ruleFieldControl,
            operator: formData.ruleOperatorControl,
            value: formData.ruleValueControl,
          }
          this.onValueChange()
        }
      })
  }

  private initFormValues(): void {
    this._variables = this.service.ruleVariables
    this._fields = this._variables.map(r => r.name)
    this._operators = this.service.ruleOperators
    this._values = this.service.ruleValues
  }

  private patchRuleFromOutside(): void {
    if (this.ruleInput) {
      this.ruleForm.patchValue({
        ruleFieldControl: this.ruleInput.field,
        ruleOperatorControl: this.ruleInput.operator,
        ruleValueControl: this.ruleInput.value,
      })
    }
  }

  ngOnInit(): void {
    this.initFormValues()
    this.initControls()
    this.initForm()
    this.patchRuleFromOutside()
    this.watch()
  }

  ngOnDestroy() {
    if (this._subscription) {
      this._subscription.unsubscribe()
    }
  }
}
